import { useEffect, useState } from "react";
// style
import Style from "./ModalMessage.module.css";

const ModalMessage = ({
  height,
  width,
  isMissingFieldsModal,
  modalMessage,
  setModalIsOpen,
  reloadProp,
  fontSizeProp,
}) => {
  const [heightPercentage, setHeightPercentage] = useState("20%");
  const [widthPercentage, setWidthPercentage] = useState("30%");
  const [fontSize, setFontSize] = useState("1.5em");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (height) {
      setHeightPercentage(height);
    }

    if (width) {
      setWidthPercentage(width);
    }

    if (fontSizeProp) {
      setFontSize(fontSizeProp);
    }

    if (modalMessage) {
      if (isMissingFieldsModal) {
        let fieldsMessage = "";
        for (let i = 0; i < modalMessage.length; i++) {
          fieldsMessage += modalMessage[i];
          if (i !== modalMessage.length - 1) {
            fieldsMessage += ", ";
          }
        }
        setMessage(fieldsMessage);
      } else {
        setMessage(modalMessage);
      }
    }
  }, [fontSizeProp, height, isMissingFieldsModal, modalMessage, width]);

  const handleYesButton = () => {
    setModalIsOpen(false);
    if (reloadProp) {
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  };

  return (
    <div className={Style.ModalContainerOverlay}>
      <div
        className={Style.Modal}
        style={{ height: heightPercentage, width: widthPercentage }}
      >
        {isMissingFieldsModal && (
          <p className={Style.ModalTitle}>Molimo popunite sva polja: </p>
        )}
        <div className={Style.ModalMessageContainer}>
          <div
            className={Style.ModalMessageMessage}
            style={{ fontSize: fontSize }}
          >
            <p className={Style.MissingFieldsText}>{message}</p>
          </div>
        </div>
        <div className={Style.ModalButtonsContainer}>
          <button
            onClick={() => handleYesButton()}
            className={Style.ModalButton}
          >
            U REDU
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalMessage;
